import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "rhombus-react";
import classNames from "classnames";

import { getCreativeClass } from "utils/CreativeMap";
import { genCreativeNameRowId } from "widgets/grid/columns/Creatives";
import { SOCIAL_AD_TYPES, IMAGE_ICONS, DYNAMIC_AUDIO, VAST_YOUTUBE } from "utils/constants";
import { isPartnerVAST, hasClosedCaption } from "utils/CreativeActions";
import { isCtvCreative, isSocialPreviewDisabled, safeDecodeURIComponent, transcodingChecks } from "utils/common";
import { useShiftClick } from "hooks/useShiftClick";

import "./CreativeName.css";

/**
 * CreativeName Cells
 */
export default function CreativeName(props){
	let { dependentValues, value } = props
		, { adType = "",
			creativeId,
			libraryId,
			isSocialCreative,
			isIncomplete,
			type,
		} = dependentValues
		, shiftClick = useShiftClick(creativeId, type)
		, { pathname } = useLocation()
		, baseLibraryRoute = `/library/${libraryId}`
		, isRouteDisallowed = pathname === `${baseLibraryRoute}/modal/create-concept/open/`
		, previewType = isSocialCreative ? "social" : "basic"
		, adClasses = {
			"type-icon":true,
			[`cell-type-creative-${adType}`]:true,
		}
		, iconName = adType.toLowerCase()
		, isDisabled = isIncomplete || isSocialPreviewDisabled(dependentValues) || isRouteDisallowed || isCtvCreative(dependentValues)
		, isTranscodedError  = transcodingChecks.error(dependentValues)
		, iconSrc = IMAGE_ICONS[adType]
		, displayName = safeDecodeURIComponent(value)
		, $name = null
		;

	if(isPartnerVAST(adType)){
		// TODO: Remove after upgrading to Rhombus 2.9.1
		iconName = "dynamic_preroll";
	}

	if(isCtvCreative(dependentValues)){
		iconName = "preroll";
	}

	if(adType === DYNAMIC_AUDIO){
		iconName = "vastaudio";
	}

	if([SOCIAL_AD_TYPES.FACEBOOK_IMAGE,
		SOCIAL_AD_TYPES.FACEBOOK_VIDEO,
		SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL].includes(adType)){
		iconName = "fab fa-meta meta-logo";
	}

	if(adType === SOCIAL_AD_TYPES.REDDIT_IMAGE || adType === SOCIAL_AD_TYPES.REDDIT_VIDEO){
		iconName = "fab fa-reddit";
	}

	if(adType === VAST_YOUTUBE){
		iconName = "youtube";
	}


	const icon = iconSrc ? (<img src={iconSrc} aria-hidden title={adType} className={classNames(adClasses)} />) : (<Icon name={iconName} aria-hidden={true} title={adType} className={classNames(adClasses)} />);
	const shouldShowClosedCaptionIcon = hasClosedCaption(dependentValues);

	$name = (
		<span title={displayName}  className="name-overflow">
			<Link
				className={classNames({ "is-disabled": isDisabled || isTranscodedError })}
				to={`/library/${libraryId}/modal/preview-creative/${previewType}/${creativeId}/`}
			>
				{displayName}
			</Link>
		</span>
	);

	return (
		<label
			htmlFor={genCreativeNameRowId(creativeId)}
			onMouseDown={shiftClick}
		>
			<div className={`creative-name-col ${getCreativeClass(adType)}`}>
				{icon}
				{$name}
				{shouldShowClosedCaptionIcon && (
					<Icon
						name="fas fa-closed-captioning"
						title="Closed Caption File Attached"
						className="cc-indicator-icon"
					/>
				)}
			</div>
		</label>
	);
}

CreativeName.displayName = "CreativeName";
CreativeName.defaultProps = {
	value:null,
	dependentValues:{
		adType:"",
		creativeId:-1,
		libraryId:-1,
		approval:"",
		isSocial:false,
	},
};
